// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingCurlySeparator_container__1DcoX","image":"LandingCurlySeparator_image__1P7__"};